export type BlogSection = {
  heading: string;
  paragraphs: string[];
};

export type BlogPost = {
  slug: string;
  title: string;
  seoTitle: string;
  metaDescription: string;
  dateLabel: string;
  datePublished: string;
  excerpt: string;
  image: string;
  imageAlt: string;
  sections: BlogSection[];
};

export const posts: BlogPost[] = [
  {
    slug: "fall-cleanup-and-snow-removal-in-highland",
    title: "Fall Cleanup and Snow Removal in Highland",
    seoTitle:
      "Fall Cleanup and Snow Removal in Highland, UT | Scotty's Land Specialist",
    metaDescription:
      "Fall cleanup in Highland runs through mid-December, and into January when the snow holds off. Snow removal covers the driveway the city plow leaves behind.",
    dateLabel: "November 4, 2026",
    datePublished: "2026-11-04",
    excerpt:
      "Leaves are still on the ground, and snow is already on the mountains. Here is what to book now so a Highland lot is clear before the snow packs it down.",
    image: "/photos/highland-fall-snow-blog.jpg",
    imageAlt: "Highland yard with fallen leaves and snow on the mountains",
    sections: [
      {
        heading: "Both jobs are open right now",
        paragraphs: [
          "Fall cleanup in Highland runs through the middle of December, and into January when the snow holds off. Snow is already on the mountains, so both are booking at the same time. Waiting until the first real storm usually means the leaves are frozen into the yard and the driveway is the thing that has to be cleared first.",
          "A large Highland lot collects more than a city street does. Leaves, garden beds, and the oak brush that comes off the east side toward American Fork Canyon sit until something hauls them. The regular trash can will not take that pile.",
        ],
      },
      {
        heading: "What fall cleanup actually clears",
        paragraphs: [
          "Fall Cleanup takes the leaves, garden beds, and yard debris off the lot before the snow packs them down. The point is a yard you can use again, not a thin pass that leaves the corners full. If the pile is oak brush or a remodel cleanout, that is a haul, not a bag for the curb.",
          "Dumpster Rental is a separate job when the debris has to sit in one place while you load it. The container stays for 24 hours. Scott drops it off, you fill it that day, and he picks it up the next day.",
        ],
      },
      {
        heading: "The city plow stops at the street",
        paragraphs: [
          "Highland City plows the streets, not the driveway. The blade also pushes a ridge of snow across the opening, so the street can be clear while the drive is blocked. Scotty's does not plow city streets. Snow Removal is the driveway, the walkway, and the access you actually use.",
          "If a storm is already on the way, call or text with the address and whether you need the drive, the walk, or both. The team will say what they can fit in.",
        ],
      },
      {
        heading: "How to get on the schedule",
        paragraphs: [
          "Call or text the team at (801) 400-3346. Business hours are Monday through Friday, 11:00 AM to 7:00 PM, and texts come in day and night. Someone on the team gets back to you about the lot and a free quote before any work starts.",
          "A few photos help: the yard if you want Fall Cleanup, the drive if you want Snow Removal, and the pile if it needs a haul. Scott comes from Highland and does the work. You do not have to guess which service fits.",
        ],
      },
    ],
  },
];

export function getPost(slug: string): BlogPost | undefined {
  return posts.find((post) => post.slug === slug);
}
